// Plain, declarative copy helpers (design README §7: object-first, no "you").

export function relTime(iso?: string | null): string {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  const diff = Date.now() - t;
  const abs = Math.abs(diff);
  const m = 60_000, h = 60 * m, d = 24 * h;
  const fut = diff < 0;
  const fmt = (n: number, u: string) => (fut ? `in ${n}${u}` : `${n}${u} ago`);
  if (abs < m) return fut ? "soon" : "just now";
  if (abs < h) return fmt(Math.round(abs / m), "m");
  if (abs < d) return fmt(Math.round(abs / h), "h");
  if (abs < 2 * d) return fut ? "tomorrow" : "yesterday";
  if (abs < 30 * d) return fmt(Math.round(abs / d), "d");
  return shortDate(iso);
}

export const shortDate = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: new Date(iso).getFullYear() === new Date().getFullYear() ? undefined : "numeric" }) : "—";

export const clock = (iso?: string | null) => (iso ? new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }) : "—");

export const dayKey = (iso?: string | null) => (iso ? new Date(iso).toLocaleDateString("en-CA") : "");

export function duration(a?: string | null, b?: string | null) {
  if (!a || !b) return null;
  const mins = Math.round((new Date(b).getTime() - new Date(a).getTime()) / 60_000);
  if (mins < 1) return null;
  return mins < 60 ? `${mins} min` : `${Math.floor(mins / 60)}h ${mins % 60}m`;
}

export const fullName = (p?: { name?: string | null; last_name?: string | null } | null) =>
  p ? [p.name, p.last_name].filter(Boolean).join(" ") || "Unknown" : "Unknown";

export const initials = (s?: string | null) =>
  (s || "?").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]!.toUpperCase()).join("");

export const plural = (n: number, one: string, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;

// Deterministic avatar colors from the brand's data palette (tokens only).
const AVATAR = ["var(--pm-primary)", "var(--pm-data-photo)", "var(--pm-data-note)", "var(--pm-secondary-dark)", "var(--pm-success-dark)", "var(--pm-info-dark)"];
export function avatarColor(seed?: string | null) {
  let h = 0;
  for (const c of seed || "") h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return AVATAR[h % AVATAR.length];
}

export function greetingPart() {
  const h = new Date().getHours();
  return h < 12 ? "Morning" : h < 17 ? "Afternoon" : "Evening";
}
